module.exports = __webpack_public_path__ + "azgems-logo.88af3f1.png";